import React from 'react';
import { BLOCKS, INLINES } from '@contentful/rich-text-types';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import ContentfulEngine from '../../contentful-engine/engine';
import { Link } from 'gatsby';
import { Picture } from '../picture';

export class RichText extends React.Component {
  options = {
    renderText: text => {
      return text.split('\n').reduce((children, textSegment, index) => {
        return [...children, index > 0 && <br key={index} />, textSegment];
      }, []);
    },
    renderNode: {
      [INLINES.ASSET_HYPERLINK]: (node, children) => {
        return <a href={node.data.target.fields.file.url} target="_blank" rel="noreferrer">{ children }</a>;
      },
      [INLINES.ENTRY_HYPERLINK]: (node, children) => {
        let entry = ContentfulEngine.process(node.data.target, this.props.language);
        if (entry.type === "archiveYear") entry.slug = `/${this.props.language}/archive/${entry.year}`;
        return <Link to={entry.slug}>{ children }</Link>;
      },
      [INLINES.HYPERLINK]: (node, children) => {
        return <a href={node.data.uri} target="_blank" rel="noreferrer">{ children }</a>;
      },
      [BLOCKS.EMBEDDED_ASSET]: (node, children) => {
        return <Picture image={node.data.target.fields} />;
      }
    }
  }

  render = () => documentToReactComponents(this.props.document, this.options);
}
